import React, { useContext } from 'react';

export const SearchContextDropdown: any = React.createContext(null);

export const useSearchContextDropdown: any = () => useContext(SearchContextDropdown);
